import React from 'react';

import { SIDEBAR_CONTENT_ID } from '../../index';
import { ClientSidebarManager } from '../../content/ClientSidebarManager';

export const FilterTrayTestComponent = (): JSX.Element => {
  return <div id={SIDEBAR_CONTENT_ID} data-test-id="filter-wrapper" />;
};

export const resetMfeFilterTrayState = (): void => {
  ClientSidebarManager.reset();
};
